interface IconProps {
  readonly width?: number;
  readonly height?: number;
  readonly iconFill?: string;
  readonly className?: string;
}

export default function ModalInfoIcon({ width, height, iconFill, className }: IconProps) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <circle cx="7" cy="7" r="7" fill={iconFill} />
      <path
        d="M7.65 6V10.9H6.35V6h1.3ZM7.75 4.4c0 .13-.025.25-.075.36a.72.72 0 0 1-.195.285.73.73 0 0 1-.285.195.87.87 0 0 1-.36.07.87.87 0 0 1-.36-.07.73.73 0 0 1-.285-.195.72.72 0 0 1-.195-.285A.93.93 0 0 1 6 4.4c0-.13.025-.25.075-.36a.72.72 0 0 1 .195-.285.73.73 0 0 1 .285-.195.87.87 0 0 1 .36-.07c.13 0 .25.025.36.07.11.045.21.11.285.195.083.085.15.185.195.285.05.11.075.23.075.36Z"
        fill="white"
      />
    </svg>
  );
}
